import angular from 'angular';
import mycrmInput from './mycrmInput';

export default angular
  .module('components.mycrmInput', [])
  .component('mycrmInput', mycrmInput).name;
